import { useEffect, useState } from 'react';
import { defaultRankIcons } from './assets/rank-icons';
export function uuid(hasHyphen) {
    return (hasHyphen ? 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx' : 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx').replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
export const checkOddEvenIndex = (index) => {
    return index % 2 === 0;
};
export const getType = (value) => {
    const type = typeof value;
    if (type !== 'object')
        return type;
    const string = Object.prototype.toString.call(value);
    return string.replace(/^\[object (\S+)\]$/, '$1').toLocaleLowerCase();
};
const iconCacheMap = new Map();
const iconPendingMap = new Map();
export const loadCachedIcon = (url) => {
    if (url.startsWith('data:'))
        return Promise.resolve(url);
    const cached = iconCacheMap.get(url);
    if (cached)
        return Promise.resolve(cached);
    const pending = iconPendingMap.get(url);
    if (pending)
        return pending;
    const request = fetch(url)
        .then((res) => {
        if (!res.ok)
            throw new Error(`icon request failed: ${res.status}`);
        return res.blob();
    })
        .then((blob) => {
        const objectUrl = URL.createObjectURL(blob);
        iconCacheMap.set(url, objectUrl);
        iconPendingMap.delete(url);
        return objectUrl;
    })
        .catch(() => {
        iconCacheMap.set(url, url);
        iconPendingMap.delete(url);
        return url;
    });
    iconPendingMap.set(url, request);
    return request;
};
export const useCachedIcons = (icons) => {
    const [cachedIcons, setCachedIcons] = useState(() => {
        if (!icons?.length)
            return icons;
        return icons.map((url) => iconCacheMap.get(url) || url);
    });
    useEffect(() => {
        if (!icons?.length) {
            setCachedIcons(icons);
            return undefined;
        }
        let cancelled = false;
        Promise.all(icons.map((url) => loadCachedIcon(url))).then((result) => {
            if (!cancelled)
                setCachedIcons(result);
        });
        return () => {
            cancelled = true;
        };
    }, [icons]);
    return cachedIcons;
};
export const default_icon = defaultRankIcons;
